<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">TELEFONO WHATSAPP</div>
</div>

<!-- Modal body -->
<div class="modal-body">

    <div class="row pt-4 px-4">
        <form [formGroup]="formBuilder">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="m-3">
                    <label for="field_whatsapp" class="form-label label-fw">
                        Telefono per WhatsApp (Inserire anche prefisso es: 39XXXXXXXX)
                    </label>
                    <input formControlName="whatsapp" name="whatsapp" type="tel" class="form-control form-fw "
                        id="field_whatsapp" placeholder="Whatsapp" pattern="([0-9]*)" maxlength="13">
                    <div *ngIf="whatsapp.invalid && (whatsapp.dirty || whatsapp.touched)" class="text-danger">
                        <div *ngIf="whatsapp.errors?.['required']">
                            Telefono whatsapp Richiesto.
                        </div>
                        <div *ngIf="whatsapp.errors?.['maxlength']">
                            Telefono whatsapp non può avere più di 13 numeri
                        </div>
                        <div *ngIf="whatsapp.errors?.['pattern']">
                            Telefono whatsapp formato errato
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>



    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3"
                    [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false"
                    (click)="clickButtonSave()">Conferma</button>
            <button type="button" class="btn btn-outline-fw text" (click)="clickButtonCancel()">Annulla</button>
        </div>
    </div>
</div>